import { createSlice } from "@reduxjs/toolkit";
import Axios from "axios";
import { BASE_API_URL } from "../../utils/constants";

const baseURL = BASE_API_URL;

export const thusermaintenance = createSlice({
  name: "THUserMaintenance",
  initialState: {
    error: false,
    TrackAdminUsers: [],
    isLoaded: false,
    isDataSentSuccess: false,
    isDataSentFailure: false,
  },
  reducers: {
    setTrackAdminUsers: (state, { payload }) => {
      state.error = false;
      state.TrackAdminUsers = payload;
    },
    setError: (state) => {
      state.error = true;
    },
    setLoaded: (state, { payload }) => {
      state.isLoaded = true;
      state.isDataSentSuccess = false;
      state.isDataSentFailure = false;
     },
     setDataSuccess: (state, {payload}) => {
      console.log('payload', payload)
       state.isLoaded = false;
       state.isDataSentSuccess = payload;
       state.isDataSentFailure = false;
     },
     setDataFailure: (state, payload) => {
       state.isLoaded = false;
       state.isDataSentSuccess = false;
       state.isDataSentFailure = true;
     },
  },
});

// Action creators are generated for each case reducer function
export const { setTrackAdminUsers, setError, setLoaded, setDataFailure, setDataSuccess } =
  thusermaintenance.actions;

export default thusermaintenance.reducer;

export function addAdminUser(username, selectedroles) {
  const properties = { username, selectedroles };
  return (dispatch) => {
    dispatch(setLoaded())
    Axios.post(
      `${baseURL}/addUser`,
      { properties },
      {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        dispatch(setDataSuccess(res.data.message))
        console.log("res from getnomination list based on skills", res.data);
      })
      .catch((err) => {
        dispatch(setError(err));
        dispatch(setDataFailure())
        console.error("error is", err);
      });
  };
}
export const fetchTHAdminUser = (trackId) => {
  return (dispatch) => {
    Axios.get(`${baseURL}/thAdminUser/${trackId}`, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        console.log('resss----', res.data)
        dispatch(setTrackAdminUsers(res.data))
      })
      .catch((err) => {
        // dispatch(setError(err));
        console.error("error is", err);
      });
  };
};
export const saveTHAdminUsers = (user) => {
  return (dispatch) => {
    Axios.post(`${baseURL}/saveThAdmins`, {user},{
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      }
    }).then((res) =>{
      console.log("res from admin list based on skills", res.data);
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  }
}